import React, { useContext, useEffect, useState } from 'react';
import {
  bool, shape, string
} from 'prop-types';
import {
  params,
  string as stringType,
  shape as shapeType,
  useDataModel
} from '@thd-nucleus/data-sources';
import axios from 'axios';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Drawer, DrawerItem } from '@thd-olt-component-react/drawer';
import { ARContent } from './components/ARContent/ARContent.component';
import './AugmentedReality.style.scss';
import { ARInstructions } from './components/ARInstructions/ARInstructions';

export const AugmentedReality = ({ forwardedRef, instructions, itemId }) => {
  const experienceContext = useContext(ExperienceContext);
  const [assetLink, setAssetLink] = useState('');
  const [loadedAsset, setLoadedAsset] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [supported, setSupported] = useState(false);

  // prefetch asset
  useEffect(() => {
    if (drawerOpen && instructions) {
      axios.get(assetLink).then(() => {
        setLoadedAsset(assetLink);
      }).catch(() => {
        // if something went wrong, don't block the user - give them degraded experience
        setLoadedAsset(assetLink);
      });
    }
  }, [drawerOpen]);
  // Check for support on load
  const supportsAR = () => {
    const userAgent = window?.navigator?.userAgent?.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  };
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const anchor = window.document.createElement('a');
      if (supportsAR() || (anchor && anchor.relList && anchor.relList.supports('ar'))) {
        setSupported(true);
      }
    }
  }, []);
  const { data, loading, error } = useDataModel('product', { variables: { itemId } });
  const { channel } = experienceContext;
  const isMobile = channel === 'mobile';

  if ((error && !data) || !data || loading || !isMobile || !supported) {
    return null;
  }

  const { product } = data || {};
  const { media } = product || {};
  const { augmentedRealityLink } = media || {};
  const { usdz } = augmentedRealityLink || {};

  if (!usdz) {
    return null;
  }
  if (!assetLink) {
    setAssetLink(`https://assets.homedepot-static.com/mobile-apps/3d/usdz/${usdz}`);
  }
  return (
    <div data-component="AugmentedReality">
      <ARContent
        assetLink={assetLink}
        forwardedRef={forwardedRef}
        onClick={instructions ? () => setDrawerOpen(true) : null}
      />
      {instructions && (
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          position="bottom"
          width="100%"
          height="80%"
          closeOnOutsideClick
          initialItem="ar-instructions"
        >
          <DrawerItem name="ar-instructions">
            <ARInstructions loadedAsset={loadedAsset} onViewerClick={() => setDrawerOpen(false)} />
          </DrawerItem>
        </Drawer>
      )}
    </div>
  );
};

AugmentedReality.displayName = 'AugmentedReality';

AugmentedReality.dataModel = {
  product: params({
    itemId: stringType().isRequired()
  })
    .shape({
      dataSources: stringType(),
      media: shapeType({
        augmentedRealityLink: shapeType({
          usdz: stringType()
        })
      })
    })
};

AugmentedReality.propTypes = {
  forwardedRef: shape({}),
  instructions: bool,
  itemId: string.isRequired
};

AugmentedReality.defaultProps = {
  forwardedRef: null,
  instructions: false
};
